import { Injectable } from '@angular/core';
import { ConsumeService } from './consume.service';
import { Observable, of } from 'rxjs';
import { BBVACardsResponse, BBVACreateOrderResponse, BBVAOpenTransactionsResponse, BBVAParamsResponse, DeleteCardReq } from '../model/http/bbva.model';
import { Endpoints } from 'src/environments/endpoints';
import { ConfirmOrderReq } from '../model/http/ordersresume.model';
import { BBVATransactionsMock } from 'src/mocks/bbvaMocks';
import { CreateBBVAOrder, PayInvoiceWithCard, PaypalInvoiceChangePayment } from '../model/http/invoices-Pending';
import { BaseResponseHttp } from '../model/http/commons.model';

@Injectable({
  providedIn: 'root'
})
export class BBVAPaymentsService {

  constructor(private consumeService: ConsumeService) { }

  createBBVAOrder = (data: ConfirmOrderReq): Observable<BBVACreateOrderResponse> =>
    this.consumeService.httpPost(Endpoints.bbva.createCarOrder, data)

  createBBVAOrderInvoice = (data: CreateBBVAOrder, isCreate: boolean): Observable<BBVACreateOrderResponse> =>
    this.consumeService.httpPost(isCreate ? Endpoints.bbva.createInvoices : Endpoints.bbva.changeInvoicePayment, data)

  transactions = (cardCode: string): Observable<BBVAOpenTransactionsResponse> =>
    this.consumeService.httpGet(`${Endpoints.bbva.transactions}${cardCode}/request/notanswered`)

  cancelTransactions = (request: Array<string>): Observable<BaseResponseHttp> =>
    this.consumeService.httpPost(`${Endpoints.bbva.cancelTransactions}`, request)

  getBBVAParams(): Observable<BBVAParamsResponse> {
    return this.consumeService.httpGet(Endpoints.bbva.getParams);
  }

  getCards(cardCode: string): Observable<BBVACardsResponse> {
    return this.consumeService.httpGet(`${Endpoints.bbva.getCards}?cardcode=${cardCode}`);
  }

  deleteCard(req: DeleteCardReq): Observable<BaseResponseHttp> {
    return this.consumeService.httpPost(Endpoints.bbva.deleteCard, req);
  }
}
